import { PaginationState, UserProfile } from "../models/admin.model";

export namespace Admin {
    export class UpdateSelectedCountries {
        static readonly type = '[Admin] Update Selected Countries';
        constructor(public payload: { selectedCountries: string[] }) { }
    }

    export class SelectVehicle {
        static readonly type = '[Admin] Select Vehicle';
        constructor(public payload: { selectedVehicle: string }) { }
    }

    export class UpdateVehicleDetails {
        static readonly type = '[Admin] Update Vehicle Details';
        constructor(public payload: { vehicleDetails: any }) { }
    }

    export class LoadUserProfile {
        static readonly type = '[Admin] LoadUserProfile';
        constructor(public accountId: string) { }
    }

    export class LoadUserProfileSuccess {
        static readonly type = '[Admin] LoadUserProfileSuccess';
        constructor(public userProfile: UserProfile) { }
    }

    export class LoadUserProfileFail {
        static readonly type = '[Admin] LoadUserProfileFail';
        constructor(public error: any) { }
    }

    export class UpdatePagination {
        static readonly type = '[Admin] Update Pagination';
        constructor(public payload: { pagination: PaginationState }) { }
    }

    export class UpdateSort {
        static readonly type = '[Admin] Update Sort';
        constructor(public payload: { sort: string }) { }
    }
}
